module.exports = "/2/3-switch-case-statements/index.html.51348d4d78f70d37586bb9c11de9341f.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30009.md
 ** module id = 542
 ** module chunks = 0
 **/